import { HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  AfterContentChecked,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { StoreService } from 'src/app/core/services/store.service';
import { CheckoutModalComponent } from 'src/app/shared/components/checkout-modal/checkout-modal.component';
import { SnackBarService } from 'src/app/core/services/snackbar.service';
import { CustomValidator } from 'src/app/shared/ui-elements/validators/custom-validator';
import { CartItem } from 'src/app/shared/models/cart.model';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatOption } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';


interface ProductCodePayload {
  productCode: string;
  itemQuantity: number;
}

@Component({
  selector: 'app-delivery-detail',
  templateUrl: './delivery-detail.component.html',
  styleUrls: ['./delivery-detail.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatInputModule,
    FormsModule,
    MatOption,
    MatSelectModule,
  ],
})
export class DeliveryDetailComponent implements OnInit {
  storeurl: string = '';
  total: number = 0;
  count: number = JSON.parse(localStorage.getItem('cartCount')!);
  cart: CartItem[] =
    JSON.parse(localStorage.getItem(this.store.getStoreCartKey('cart'))!) || [];
  warning: boolean = false;
  deliveryTypes: string[] = [];
  selectedShipping: string = '';
  copy: boolean = false;
  delivery: string = '';
  states: any[] = [];
  cities: string[] = [];
  deliveryCharge: any;

  // discount states
  discountCode: string = '';
  isApplyingDiscount: boolean = false;
  discountAppliedSuccess: boolean = false;

  @Input() availableShipping!: string[];
  @Input() deliveryDetail!: FormGroup;
  @Input() order: any;
  // storeCode passed down from cart-checkout (this.stores.store_code)
  @Input() storeCode!: string;

  // Emits the full validate response when discount is successfully applied
  @Output() discountApplied = new EventEmitter<any>();
  @Output() shippingValueEmitter = new EventEmitter<string>();
  @Output() orderValueEmitter = new EventEmitter<any>();

  constructor(
    public store: StoreService,
    public http: HttpClient,
    public fb: FormBuilder,
    private snackBar: SnackBarService,
  ) {
    this.http.get<any[]>('./assets/shipping.json').subscribe((data) => {
      this.states = data;
    });
  }

  countries = ['Nigeria'];

  codes = ['+234'];

  selectedValue($event: any) {
    this.selectedShipping = $event.value;
    const pickupIndex = this.availableShipping.findIndex(
      (ship: string) => ship === 'PICKUP_IN_STORE',
    );
    if (this.availableShipping.length > 1) {
      if (this.selectedShipping === 'Ship') {
        pickupIndex === 1
          ? this.shippingValueEmitter.emit(this.availableShipping[0])
          : this.shippingValueEmitter.emit(this.availableShipping[1]);
      } else if (this.selectedShipping === 'select a shipping method') {
        this.shippingValueEmitter.emit(undefined);
      } else {
        pickupIndex === 1
          ? this.shippingValueEmitter.emit(this.availableShipping[1])
          : this.shippingValueEmitter.emit(this.availableShipping[0]);
      }
    } else if (this.availableShipping.length === 1) {
      this.shippingValueEmitter.emit(this.availableShipping[0]);
    }
  }

  ngOnInit(): void {
    this.availableShipping.map((option: any) => {
      if (option === 'PICKUP_IN_STORE') {
        this.deliveryTypes.push('Pickup in store');
      } else {
        this.deliveryTypes.push('Ship');
      }
    });
  }

  ngAfterContentChecked(): void {
    this.total = JSON.parse(
      localStorage.getItem(this.store.getStoreCartKey('cartTotal'))!,
    );
  }

  // Discount Logic
  //  Guards:
  //   1. Delivery details form must be fully valid.
  //   2. A discount code must be entered.
  applyDiscount(): void {
    // Guard 1: form must be complete
    // if (this.deliveryDetail.invalid) {
    //   CustomValidator.validateAllFormFields(this.deliveryDetail);
    //   this.snackBar.openSnackBar(
    //     'Please complete your delivery details before applying a discount.',
    //     'error-snackbar',
    //   );
    //   return;
    // }

    // Guard 2; discount code must be provided
    if (!this.discountCode || !this.discountCode.trim()) {
      this.snackBar.openSnackBar(
        'Please enter a discount code.',
        'error-snackbar',
      );
      return;
    }

    // build product codes from cart
    const cartItems: CartItem[] =
      JSON.parse(localStorage.getItem(this.store.getStoreCartKey('cart'))!) ||
      [];

    const products: ProductCodePayload[] = cartItems.map((item) => ({
      productCode: item.product.product_code,
      itemQuantity: item.cartQuantity,
    }));

    const userEmail: string =
      this.deliveryDetail.get('addressDTO')?.get('email')?.value || '';

    const cartAmount: number = this.store.reduceCartPrice();

    const payload = {
      discountCode: this.discountCode.trim(),
      storeCode: this.storeCode,
      cartAmount,
      products,
      userIdentifier: userEmail,
    };

    this.isApplyingDiscount = true;

    this.store.validateDiscount(payload).subscribe({
      next: (response: any) => {
        this.isApplyingDiscount = false;

        if (response?.valid && response?.productDetails?.length > 0) {
          this.discountAppliedSuccess = true;
          this.discountApplied.emit(response);
          this.snackBar.openSnackBar(
            'Discount applied successfully!',
            'success-snackbar',
          );
        } else {
          this.snackBar.openSnackBar(
            response?.message || 'Discount code is not valid.',
            'error-snackbar',
          );
        }
      },
      error: (_err: any) => {
        this.isApplyingDiscount = false;
        this.snackBar.openSnackBar(
          'Unable to apply discount. Please try again.',
          'error-snackbar',
        );
      },
    });
  }
}
